<script lang="ts">
    import {onDestroy, onMount} from 'svelte';
    import {slide} from 'svelte/transition';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    let internetConnection = navigator.onLine;
    let barShown = !internetConnection;

    onMount(() => {
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
    });

    onDestroy(() => {
        window.removeEventListener('online', handleOnline);
        window.removeEventListener('offline', handleOffline);
    });

    const handleOnline = () => {
        internetConnection = true;

        setTimeout(() => {
            barShown = false;
        }, 2500);
    };

    const handleOffline = () => {
        internetConnection = false;
        barShown = true;
    };
</script>

{#if barShown}
    <div class="erp-connection-bar"
         transition:slide={{duration: 250}}
         class:connected={internetConnection}
         class:disconnected={!internetConnection}>

        {#if internetConnection}
            <IconedContent icon="check-circle" iconColor="white" gap="10px">
                <span>Připojení k internetu bylo obnoveno</span>
            </IconedContent>
        {:else}
            <IconedContent icon="exclamation" iconColor="white" gap="10px">
                <span>Připojení k internetu bylo ztraceno</span>
            </IconedContent>
        {/if}
    </div>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .erp-connection-bar {
        width: 100%;
        padding: @spacing-s 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        overflow: hidden;
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        transition: background-color 0.3s ease-in-out;

        &.connected {
            background-color: var(--success-green);
        }

        &.disconnected {
            background-color: var(--danger-red);
        }
    }
</style>